import { createContext, useState, useEffect } from 'react'
import { jwtDecode } from "jwt-decode";
import { useNavigate } from 'react-router-dom'
import axios from "axios";
import { ProgressSpinner } from 'primereact/progressspinner';
import { toast } from 'react-toastify';


const AuthContext = createContext()

export default AuthContext;


export const AuthProvider = ({children}) => {

    const BASE_URL = process.env.REACT_APP_MAIN_URL

    const [authTokens, setAuthTokens] = useState(()=> 
        localStorage.getItem('authTokens') 
        ? JSON.parse(localStorage.getItem('authTokens')) 
        : null)

    // const [user, setUser] = useState(()=> 
    //     localStorage.getItem('authTokens') 
    //     ? jwtDecode(localStorage.getItem('authTokens')) 
    //     : null)
    const [user, setUser] = useState(null)

    const [loading, setLoading] = useState(true)
    const [loginError, setLoginError] = useState(null)

    const navigate = useNavigate();

    const loginUser = async (values )=> {
        setLoading(true)
        await axios.post(`${BASE_URL}/api/login/`, values)
            .then((response) => {
                setLoading(false);
                setAuthTokens(response.data);
                setUser(jwtDecode(response.data.access));
                localStorage.setItem('authTokens', JSON.stringify(response.data));
                localStorage.setItem('token', response.data.access);
                if (jwtDecode(response.data.access)?.user_type === 'ADMIN'){
                    navigate('/')
                }else if(jwtDecode(response.data.access)?.user_type === 'STORE'){
                    navigate('/stock')
                }else if(jwtDecode(response.data.access)?.user_type === 'SALE'){
                    navigate('/sale')
                }else if(jwtDecode(response.data.access)?.user_type === 'REPORT'){
                    navigate('/report')
                }else{
                    navigate('/no-permission');
                }
            })
            .catch((error) => {
                setLoading(false);
                if (error.response?.status === 401 || error.response?.status === 400) {
                    toast.error('No active account found with the given credentials');
                    setLoginError(error.response?.data.detail);
                }else if(error.response?.status === 404){
                    toast.info('Login URL might be changed!!! Contact with the Software Engineer.');
                    setLoginError('URL ', error.response?.statusText);
                }else {
                    toast.error('Something went wrong. Please try again later.');
                    setLoginError("Something went wrong. Please try again later.");
                }
            });
    }


    const logoutUser = () => {
        setAuthTokens(null)
        setUser(null)
        localStorage.removeItem('authTokens')
        localStorage.removeItem('token')
        window.localStorage.clear();
        localStorage.clear();
        navigate('/login');
    }


    const updateToken = async ()=> {

        await axios.post(`${BASE_URL}/api/login/refresh/`, {'refresh':authTokens?.refresh})
            .then((response) => {
                setAuthTokens(response.data)
                setUser(jwtDecode(response.data.access))
                localStorage.setItem('authTokens', JSON.stringify(response.data))
                localStorage.setItem('token', response.data.access)
            })
            .catch((error) => {
                logoutUser()
            });
        if(loading){
            setLoading(false)
        }
    }

    const contextData = {
        loading: loading,
        loginError: loginError,
        user:user,
        // authTokens:authTokens,
        loginUser:loginUser,
        logoutUser:logoutUser,
    }


    useEffect(()=> {

        if(loading){
            updateToken()
        }

        let fourMinutes = 1000 * 60 * 60 * 12 //miliseconds * seconds * minutes * hours

        let interval =  setInterval(()=> {
            if(authTokens){
                updateToken()
            }
        }, fourMinutes)
        return ()=> clearInterval(interval)
    },)
    // }, [authTokens, loading])

    return(
        <AuthContext.Provider value={contextData} >
            {loading ? 
                <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <ProgressSpinner  style={{width: '100px', height: '100px'}} strokeWidth="3" fill="white" animationDuration="1s" />
                </div> 
            : children}
        </AuthContext.Provider>
    )
}
